import React from "react";
import {Tree} from "antd";
import {SettingOptModeEnum, useSettingModel} from "../settingModel";

export const TreePanel = () => {
    const {
        selectedRowKeys,
        setSelectedRowKeys,
        getTreeData,
        setOptMode
    } = useSettingModel();
    return (
        <div className="tree-list-box">
            <Tree
                selectedKeys={selectedRowKeys}
                titleRender={(node) => `[${node.key}]  ${node.title}`}
                onSelect={selectedKeys => {
                    setSelectedRowKeys([...selectedKeys]);
                    setOptMode(SettingOptModeEnum.EDIT);
                }}
                treeData={getTreeData()}
            />
        </div>
    )
}